export enum PartnerCSSResource {
    ICONS = 'https://smartdesign.immowelt.org/iconfont/5.3.0/smartdesign-icons.css',
    FONT = 'https://smartdesign.immowelt.org/font/1.4.5/css/immo-sans.css',
}

export enum PartnerJSResource {
    POLYFILLS = 'https://s.immowelt.org/estateexpose-smart-webcomponent/public/polyfills.js',
    MAIN = 'https://s.immowelt.org/estateexpose-smart-webcomponent/public/main.js',
    SCRIPT = 'https://s.immowelt.org/estateexpose-smart-webcomponent/public/scripts.js',
}
